exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-map-marker .undefined{width:20px;height:20px;background-color:red}", ""]);

// exports
